import api from "@/services/api";
import { ClientDetailsType } from "@/types/client/Client";

class AutoPreRegister {
  execute = async (document: string, name?: string, phone?: string, email?: string) => {
    const payload: any = {
      document: document
    };

    // Adicionar campos opcionais se fornecidos
    if (name && name.trim()) {
      payload.name = name;
    }
    if (phone && phone.trim()) {
      payload.phone = phone;
    }
    if (email && email.trim()) {
      payload.email = email;
    }

    // Obter indicationKey do session info
    const sessionInfo = await api().get(`/auth/session-info`);
    if (sessionInfo.data.indicationKey) {
      payload.indicatorKey = sessionInfo.data.indicationKey;
    }

    // Sempre enviar indicatorType como PARTNER
    payload.indicatorType = "PARTNER";

    try {
      const clientSend = await api().post(`/customer/pre-registration`, payload);
      return clientSend.data as ClientDetailsType;
    } catch (error) {
      console.error("Erro ao cadastrar cliente no pré-registro:", error);
      throw error;
    }
  };
}

export { AutoPreRegister };
